import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { EduEvent } from '@/components/home/messages/EduEvent';
import useAppEvents from '@/patient-app-common/hooks/useAppEvents';

export function PastEventList() {
  const { t } = useTranslation('progress');
  const { completedEvents, eventsWithSchedule } = useAppEvents();
  const { messageEvents } = eventsWithSchedule;

  const completedIds = completedEvents.map((event) => event.applicationEventId);

  const pastEvents = useMemo(() => {
    if (!messageEvents?.length || !completedIds?.length) return [];

    return messageEvents
      .filter((event) => event.eventType === 'education')
      .filter((event) => completedIds.includes(event.id));
  }, [completedIds, messageEvents]);

  if (!pastEvents.length) {
    return (
      <div className="flex justify-center p-8">
        <h1 className="font-light text-default-600 text-lg">
          {t('pasteventlist.empty_text')}
        </h1>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="font-semibold text-xl">{t('pasteventlist.title')}</h1>
      {pastEvents.reverse().map((event, index) => (
        <EduEvent
          data-test="message"
          disableRead
          event={event}
          index={index}
          size={EduEvent.length}
        />
      ))}
    </div>
  );
}
